import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { signOut } from '@/lib/auth';
import type { UserMeta } from '@shared/protocol';

export function TopBar({ user }: { user: UserMeta }) {
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate('/login');
  }

  return (
    <header className="h-14 border-b bg-card flex items-center justify-between px-6">
      <div /> {/* breadcrumbs placeholder */}
      <div className="flex items-center gap-3">
        <div className="text-sm">
          <div className="font-medium">{user.name ?? user.email}</div>
          {user.name && <div className="text-xs text-muted-foreground">{user.email}</div>}
        </div>
        <Button variant="ghost" size="icon" onClick={handleSignOut} aria-label="Sign out">
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
    </header>
  );
}
